"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("./client");
var utils_1 = require("./utils");
var stompProtocol_1 = require("./protocol/stomp/stompProtocol");
// The `webstomp` Object
exports.stompobservable = {
    VERSIONS: stompProtocol_1.VERSIONS,
    // This method creates a WebSocket client that is connected to
    // the STOMP server located at the url.
    client: function (url, options, protocols) {
        if (options === void 0) { options = {}; }
        if (protocols === void 0) { protocols = stompProtocol_1.VERSIONS.supportedProtocols(); }
        setupLogger(options);
        var createWsConnection = function () { return new WebSocket(url, protocols); };
        return new client_1.default(createWsConnection, options);
    },
    // This method is an alternative to `webstomp.client()` to let the user
    // specify the WebSocket to use via the function createWsConnection
    // (returning either a standard HTML5 WebSocket or a similar object).
    over: function (createWsConnection, options) {
        if (options === void 0) { options = {}; }
        setupLogger(options);
        return new client_1.default(createWsConnection, options);
    }
};
var setupLogger = function (options) {
    var _a = options.debug, debug = _a === void 0 ? false : _a;
    utils_1.logger.setDebug(!!debug);
};
